export default __webpack_public_path__ + "static/media/K_fici.48a07d36.gif";